export class DateTimeUtil {
  /**
   * Generate an array of ISO timestamp strings between two dates using a fixed minute step.
   * Example: generateIsoRange(start, end, 15) -> values every 15 minutes.
   */
  public static generateIsoRange(start: Date, end: Date, stepMinutes: number): string[] {
    const result: string[] = []

    const current = new Date(start.getTime())

    while (current.getTime() <= end.getTime()) {
      // Push ISO formatted timestamp
      result.push(current.toISOString())

      // Increase by step
      current.setTime(current.getTime() + stepMinutes * 60 * 1000)
    }

    return result
  }

  public static getOnlyDate(date?: Date): Date {
    if (!!date) {
      const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())

      return dateOnly
    } else {
      return date
    }
  }
}
